/**
 * Get the language based on the current location pathname.
 *
 * @returns The language code.
 */
export function getLang(): string {
  return location.pathname.startsWith('/uk') ? 'en' : 'es';
}
